const Resources = {

    table_headers: [
        { 
          text:     'Walking #',
          value:    'walking_number'
        },
        { 
            text:   'Door #',
            value:  'door_number'
        },
        { 
            text:   'Description',
            value:  'sort_desc',
            type:   ''
        },
        { 
            text:   'Sq feet',
            value:  'sq_ft'
        },
        { 
            text:   'Area',
            value:  'area_name'
        },
        {   
            text:   'DailyTask(s)',
            value:  'daily_tasks',
            type: 'tasks'
        },
        {   
            text:   'PolicingTask(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
        },
        {   
            text:   'ProjectTask(s)',
            value:  'project_tasks',
            type:   'tasks',
            class:  'header-orange',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Utilities',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Mass Restore Bed Codes',
            href:   '/utilities-mass-restore-bed-codes',
            arrow:  "",
        },
    ],

}

export default Resources;